export const electronicSupport: Array<string> = [
    "SM100 Weighing Scale",
    "Platform",
    "Table Top",
    "Floor Scale",
    "Truck Scale",
    "Rall Scale",
];

export const PosSupport: Array<string> = [
    "System Unit (CPU)",
    "Monitor",
    "POS Printer",
    "Barcode Scanner",
    "Mouse",
    "Keyboard",
    "UPS Backup",
    "Automatic Voltage Regulator (AVR)",
];

export const desktopSupport: Array<string> = [
    "System Unit (CPU)",
    "Monitor",
    "Mouse",
    "Keyboard",
    "Automatic Voltage Regulator (AVR)",
];

export const laptopSupport: Array<string> = [
    "System Unit (CPU)",
    "Charger",
    "Battery",
    "Memory",
    "Keyboard",
];

export const NetworkConnection: Array<string> = [
    "Wired Connection",
    "Wireless Connection",
    "Network File Sharing",
];

export const PrinterSupport: Array<string> = [
    "Laser Printer",
    "All-in-one Printer",
    "Ink-jet Printer",
];

export const ElectronicsSupport: Array<string> = [
    "Tablet",
    "Biometrics",
    "Mobile Phone",
];
